import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: "1", text: "在庫", enum: "NOMAL" },
  { value: "2", text: "不良在庫", enum: "BAD" },
]);
